module.exports = __webpack_public_path__ + "static/media/yearn__brand.a62410f8.png";